import {
  ADD_ORDER,
  SET_CHECKOUT_ORDER_INFO,
  SET_CURRENT_ORDER,
  SET_ORDERS,
  UPDATE_ORDER,
} from "./types";

export const setOrders = (data) => ({
  type: SET_ORDERS,
  data: data,
});

export const addOrder = (data) => ({
  type: ADD_ORDER,
  data: data,
});

export const setCheckoutOrderInfo = (data) => ({
  type: SET_CHECKOUT_ORDER_INFO,
  data: data,
});

export const setCurrentOrder = (data) => ({
  type: SET_CURRENT_ORDER,
  data: data,
});

export const updateOrder = (data) => ({
  type: UPDATE_ORDER,
  data: data,
});
